import { useEffect, useState } from "react";
import axiosInstance from "../../../apiInstances/axiosInstance";
import Design1 from "../../../assets/home/home2.jpg";
import FilterScreen from "../FilterScreen/FilterScreen";

const Homebanner = ({ setSearch }) => {

  return (
    <>
      <div className="relative w-full lg:container mx-auto md:px-3">
        <img
          src={Design1}
          alt="home banner"
          className="w-full rounded-none md:rounded-[24px] h-[300px] lg:h-[380px] object-cover"
        />
        <FilterScreen setSearch={setSearch} />
      </div>
    </>
  );
};

export default Homebanner;
